import NdisImg from "public/images/NDIS/Registered-NDIS-Provider-square.png"
import GoogleReviewImg from "public/images/Google-5-star.png"
import Image from "next/image"

import TagFilter from "./tagFilter"
import type { Dispatch, SetStateAction } from "react"
import type { FilterType } from "./blogArticleSection"

export type InsightBandProps = {
  showFilter?: boolean
  setFilter?: Dispatch<SetStateAction<FilterType>>
}
const InsightBand = ({ showFilter }: InsightBandProps) => {
  return (
    <div className={`border-t-4 border-white bg-purpleblue p-8 py-4 font-secondary xs:py-6 ml:px-16 xl:px-20`}>
      <div
        className={`container mx-auto flex items-center ${showFilter ? "justify-between" : "justify-end"} xl:max-w-7xl`}
      >
        {/* {showFilter && <TagFilter />} */}
        <div className={`flex flex-wrap items-center justify-end gap-4 xs:gap-6 md:flex-nowrap`}>
          <Image src={NdisImg} alt="NDIS-logo" height={60} className="xl:w-24" />
          <Image src={GoogleReviewImg} alt="Google-5-star" height={50} className="xl:w-48" />
        </div>
      </div>
    </div>
  )
}

export default InsightBand
